import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const NameKey = 'loginName'
//sso的appId
var AppId='408'
//sso login url
var loginUrl='https://sso.tools.zuzuche.com/?q=Login/Home&from='
//sso redirectUrl
var redirectUrl='https://sso.tools.zuzuche.com/?q=Login/Home&redirectUrl=http%3A%2F%2F127.0.0.1%3A8090%2F%23%2FloginBySSO%3Ftoken%3DSSO_TOKEN&from='
//sso logout url
var logoutUrl='http://sso.tools.zuzuche.com/?q=Login/Leave&from='
//是否使用SSO登录的开关，如果关闭则使用LDAP登录
var IsLoginBySSO = false

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getName() {
  return Cookies.get(NameKey)
}

export function setName(name) {
  return Cookies.set(NameKey, name)
}

export function removeName() {
  return Cookies.remove(NameKey)
}

//登录和退出SSO时重定向到SSO
export function redirectToSSO(loginOrLogout,isLoginBySSO, redirectTo){

  if(isLoginBySSO){
    if(loginOrLogout=="login"){
      const url = redirectTo ? `${loginUrl}${AppId}&redirectUrl=${redirectTo}` : `${loginUrl}${AppId}`
      location.assign(url)
    }else if(loginOrLogout=="logout"){
      location.assign(logoutUrl+AppId)
    }
  }

}

export function isLoginBySSO(){
  if(process.env.NODE_ENV=="development"){
    //如果是要启用LDAP登录，只需把下面IsLoginBySSO的注释去掉
    // IsLoginBySSO=false
    AppId=appId()
  }
  return IsLoginBySSO
}

//返回sso的AppId
export function appId(){
  return AppId
}



// WEBPACK FOOTER //
// ./src/utils/auth.js